import React from 'react';
import { InputContainer } from '../../components/form/form.module';

export const ShippingAddressComponent = ({libraries, countries, isAddress, onInnerFormChange, selectShippingAddress, stateValues, onFilterToStates }: any) => (<>
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                <InputContainer
                    label="Address1"
                    name="Address1"
                    onValueChange={(event: any) => {
                      onInnerFormChange(
                        event.target.value,
                        'ShippingAddress.Address1',
                        selectShippingAddress?.ShippingAddress
                      )
                    }}
                    type="text"
                    value={selectShippingAddress?.ShippingAddress?.Address1}
                />
            <InputContainer
                    label="Address2"
                    name="Address2"
                    onValueChange={(event: any) => {
                      onInnerFormChange(
                        event.target.value,
                        'ShippingAddress.Address2',
                        selectShippingAddress?.ShippingAddress
                      )
                    }}
                    type="text"
                    value={selectShippingAddress?.ShippingAddress?.Address2}
                />
           <InputContainer
                    label="City"
                    name="City"
                    onValueChange={(event: any) => {
                      onInnerFormChange(
                        event.target.value,
                        'ShippingAddress.City',
                        selectShippingAddress?.ShippingAddress
                      )
                    }}
                    type="text"
                    value={selectShippingAddress?.ShippingAddress?.City}
                />
           <InputContainer
          
          label="Country Name"
          labelField="Name"
          list={countries}
          onValueChange={(event: any) => {
            onFilterToStates(event.target.value);
           
          }}
          optionName='Choose Country'
          type="select"
          value={selectShippingAddress?.ShippingAddress?.CountryId}
          valueField="Id"
      />
                
            <InputContainer
          
          label="State Name"
          labelField="Name"
          list={stateValues}
          onValueChange={(event: any) => {
            onInnerFormChange(
                event.target.value,
                'ShippingAddress.StateProvinceId',
                selectShippingAddress?.ShippingAddress
              );
          }}
          optionName='Choose State'
          type="select"
          value={selectShippingAddress?.ShippingAddress?.StateProvinceId}
          valueField="Id"
      />
                
           <InputContainer
                    label="ZipPostalCode"
                    name="ZipPostalCode"
                    onValueChange={(event: any) => {
                      onInnerFormChange(
                        event.target.value,
                        'ShippingAddress.ZipPostalCode',
                        selectShippingAddress?.ShippingAddress
                      )
                    }}
                    type="text"
                    value={selectShippingAddress?.ShippingAddress?.ZipPostalCode}
                />
         
            { isAddress
              ? <>
            <InputContainer
                    label="FaxNumber"
                    name="FaxNumber"
                    onValueChange={(event: any) => {
                      onInnerFormChange(
                        event.target.value,
                        'ShippingAddress.FaxNumber',
                        selectShippingAddress?.ShippingAddress
                      )
                    }}
                    type="number"
                    value={selectShippingAddress?.ShippingAddress?.FaxNumber}
                />
           

        <InputContainer
            label="OpeningHours Type"
            labelField="Description"
            list={libraries.OpeningHoursType}
            onValueChange={(event: any, newValue: any) => {
              onInnerFormChange(
                event.target.value,
                'ShippingAddress.OpeningHoursTypeId',
                selectShippingAddress?.ShippingAddress
              );
            }}
            optionName='Choose OpeningHoursType'
            type="select"
            value={selectShippingAddress?.ShippingAddress?.OpeningHoursTypeId}
            valueField="Value"
        />
      <InputContainer
                    label="Geocode Accuracy"
                    name="GeocodeAccuracy"
                    onValueChange={(event: any) => {
                      onInnerFormChange(
                        event.target.value,
                        'ShippingAddress.GeocodeAccuracy',
                        selectShippingAddress?.ShippingAddress
                      )
                    }}
                    type="text"
                    value={selectShippingAddress?.ShippingAddress?.GeocodeAccuracy}
                />
            <InputContainer
                    label="Latitude"
                    name="Latitude"
                    onValueChange={(event: any) => {
                      onInnerFormChange(
                        event.target.value,
                        'ShippingAddress.Latitude',
                        selectShippingAddress?.ShippingAddress
                      )
                    }}
                    type="text"
                    value={selectShippingAddress?.ShippingAddress?.Latitude}
                />
             <InputContainer
                    label="Longitude"
                    name="Longitude"
                    onValueChange={(event: any) => {
                      onInnerFormChange(
                        event.target.value,
                        'ShippingAddress.Longitude',
                        selectShippingAddress?.ShippingAddress
                      )
                    }}
                    type="text"
                    value={selectShippingAddress?.ShippingAddress?.Longitude}
                />
          
            </>
              : null}
       </div>

    </>
)
